import React from "react";
import { ReactComponent as InfoIcon } from "@svgs/info-light.svg"

const Icon = ({ onClick }) => {	
	return (
		<div className="flex justify-end absolute right-5 top-5">
			<InfoIcon className="cursor-pointer" onClick={onClick} />
		</div>
	)
}

export default Icon;